module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-sesame.498d5bc4.svg";